import './ifmsSideMenu.css';
import React, { useContext, useEffect, useState } from 'react';

import { IfmsConfigMenuItem, IfmsConfigOperationMenu } from './config/types';
import useDeepCompareEffect from './hooks/useDeepCompareEffect';
import ApplicationContext from './ApplicationContext';
import useSideMenuHeightMonitor from './hooks/useSideMenuHeightMonitor';
import previewPrintIcon from './img/preview_print.svg';
import previewPrintIconWhite from './img/preview_print_White.svg';
import directPrintIcon from './img/direct_print.svg';
import directPrintIconWhite from './img/direct_print_White.svg';
import disablePreviewPrintIcon from './img/preview_print_disable.svg';
import disableDirectPrintIcon from './img/direct_print_disable.svg';
import fastStorage from './fastStorage';
import useGlobalYesNoDialog from './hooks/useGlobalYesNoDialog';
import _ from 'lodash';
import { useHistory } from 'react-router';
import { getRoutePath } from './util/routeUtils';
import { JobNames } from './framework.core/JobNames';
import useSystemSettings from './hooks/useSystemSettings';

export const IfmsSideMenuWidthNumber = 210;
export const IfmsSideMenuWidth = `${IfmsSideMenuWidthNumber}px`;

const ArrowIconSvgDown = '<svg class="ifms-side-menu-downarrow-icon" width="12" height="8" viewBox="0 0 12 8" xmlns="http://www.w3.org/2000/svg"><path d="M1.008 1.96579L1 1.97279L5.997 6.96678L11 1.96979L10.935 1.90479C7.626 1.98779 4.318 1.99979 1.008 1.96579Z" /></svg>';
const ArrowIconSvgUp = '<svg class="ifms-side-menu-uparrow-icon" width="12" height="8" viewBox="0 0 12 8" xmlns="http://www.w3.org/2000/svg"><path d="M10.992 6.46087L11 6.45287L5.996 1.46387L1 6.46987L1.066 6.53487C4.375 6.44687 7.682 6.42987 10.992 6.46087Z" /></svg>';

//const AutoCloseDelayMs = 500;

/*
function isHoverElementUnderSelectedSubmenu(hoverElement: Element|null, selectedSubmenuId: string): boolean {
  if (!hoverElement) {
    return false;
  }

  const checkDepth = 5;
  let checkingElement = hoverElement;
  for (let i = 0; i < checkDepth; ++i) {
    if (!checkingElement.id) {
      if (!checkingElement.parentElement) {
        break;
      }

      checkingElement = checkingElement.parentElement;
    }
    if (checkingElement.id && checkingElement.id.startsWith(selectedSubmenuId)) {
      return true;
    }

    if (!checkingElement.parentElement) {
      break;
    }

    checkingElement = checkingElement.parentElement;
  }

  return false;
}
*/

export function findOpendSideMenuIndexes() {
  const elements = document.querySelectorAll('[class*=ifms-side-menu-item-opend]');

  const uniqueClassLists = new Set();

  elements.forEach(element => {
    const classList = element.classList;
    for (let i = 0; i < classList.length; i++) {
      uniqueClassLists.add(classList[i]);
    }
  });

  return Array.from(uniqueClassLists).filter(x => String(x).startsWith('ifms-side-menu-item-opend'));
}

export function getMenuItemKey(operation: string, menuName: string, menuIndex: number): string {
  return operation ? `${operation}-${menuName}-${menuIndex}` : `${menuName}-${menuIndex}`;
}
export function getMenuItemName(operation: string, menuName: string, name: string): string {
  return operation ? `${operation}-${menuName}-${name}` : `${menuName}-${name}`;
}

function hasSideMenu(x: IfmsConfigMenuItem): boolean {
  return !!x.items && x.items.length > 0;
}

interface SubmenuSelection {
  operationInProgress: false,
  key: string,
  submenu: IfmsConfigMenuItem|null,
  opened: boolean,
  index: number, // For calculating top offset for side menu
  // Additional settings passed as properties
  operation: string,
  topBarHeight: number,
  customTopOffset: number|undefined,
  customLeftOffset: string|undefined,
  customZIndex: number|undefined,
  mX: number,
  mY: number,
};

const StorageMap: Map<string, SubmenuSelection> = new Map();

function get(id: string): SubmenuSelection {
  const result = StorageMap.get(id);
  if (result === undefined) {
    throw new Error('Invalid operation');
  }

  return result;
}

function set(id: string, s:SubmenuSelection) {
  StorageMap.set(id, s);
}

/*
function checkAndClosePopup(injectMenuId: string, popupId: string, force: boolean = false) {
  const settings = get(injectMenuId);

  if (force) {
    const popupContainerId = `${injectMenuId}-popup`;
    const existingPopup = document.getElementById(popupContainerId);
    if (existingPopup) {
      const drawer = existingPopup.childNodes[0] as Element;
      drawer.classList.remove('ifms-side-menu-open');
      set(injectMenuId, {
        ...settings,
        operationInProgress: false,
        key: '',
        submenu: null,
        opened: false,
        index: 0,
      });
    }

    const alreadySelected = document.querySelectorAll('.ifms-side-menu-item-selected');
    for (let i = 0; i < alreadySelected.length; ++i) {
      alreadySelected[i].classList.remove('ifms-side-menu-item-selected');
    }

    return;
  }

  if (!settings.opened || settings.key !== popupId) {
    // Other popup has been opened in the mean time. This operation is outdated
    return;
  }

  const hoverElement = document.elementFromPoint(settings.mX, settings.mY);

  if (!isHoverElementUnderSelectedSubmenu(hoverElement, popupId)) {
    const submenuDom = document.getElementById(settings.key);
    if (submenuDom) {
      const mouseElements = document.elementsFromPoint(settings.mX, settings.mY);

      if (!mouseElements.some(x => x.id === settings.key)) {
        submenuDom.classList.remove('ifms-side-menu-item-selected');
      }
    }

    const popupContainerId = `${injectMenuId}-popup`;
    const existingPopup = document.getElementById(popupContainerId);
    if (existingPopup) {
      const drawer = existingPopup.childNodes[0] as Element;
      drawer.classList.remove('ifms-side-menu-open');
      set(injectMenuId, {
        ...settings,
        operationInProgress: false,
        key: '',
        submenu: null,
        opened: false,
        index: 0,
      });
    }
  }
}

function injectPopup(
  containerId: string,
  submenuKey: string,
  submenu: IfmsConfigMenuItem,
  index: number,
  onMenuItemClicked: (menuItem:IfmsConfigMenuItem) => void,
  enableBranch?: boolean,
) {
  const popupContainerId = `${containerId}-popup`;
  const popupContainer = document.getElementById(popupContainerId);
  if (!popupContainer || popupContainer.childElementCount !== 1) {
    throw new Error('Invalid operation');
  }

  const settings = get(containerId);

  const menuTopOffset = settings.customTopOffset ?? (settings.topBarHeight + 68);
  const offsetTop = 30 * index + menuTopOffset - 12;  // 12px margin from top to align items
  // const width = 200;
  let submenuHeight = 0;

  // Mark submenu as selected
  const submenuDom = document.getElementById(submenuKey);
  if (submenuDom) {
    const alreadySelected = document.querySelectorAll('.ifms-side-menu-item-selected');
    for (let i = 0; i < alreadySelected.length; ++i) {
      alreadySelected[i].classList.remove('ifms-side-menu-item-selected');
    }
    submenuDom.classList.add('ifms-side-menu-item-selected');
  }

  const submenuItems = submenu.items ?? [];
  submenuItems.forEach(s => {
    submenuHeight += s.metadata?.doubleLineInMenu ? 55 : 30;
  });

  const zIndex = settings.customZIndex !== undefined ? (settings.customZIndex - 1) : 998;

  const popup = popupContainer.childNodes[0] as HTMLElement;

  popup.innerHTML = '';
  popup.id = `${submenuKey}-popup`;

  for (let i = 0; i < submenuItems.length; ++i) {
    const sx = submenuItems[i];
    const subMenuItemKey = getMenuItemKey(sx, settings.operation, submenuKey, i);

    const subMenuItem = document.createElement('div');
    subMenuItem.id = subMenuItemKey;
    subMenuItem.classList.add('ifms-side-menu-item-extended');
    if (!!sx.metadata?.doubleLineInMenu) {
      subMenuItem.classList.add('ifms-side-menu-item-large');
    }
    subMenuItem.innerHTML = sx.text as string;
    subMenuItem.onclick = () => {
      onMenuItemClicked(sx);
      checkAndClosePopup(containerId, submenuKey, true);
    };

    popup.appendChild(subMenuItem);
  }

  // popup.style.width = `${width}px`;

  const paddingTop = 13;
  const paddingBottom = 14;

  submenuHeight += (paddingTop + paddingBottom - 6); // last menu item does not have bottom margin (minus 2px to fit the border top and bottom)

  popup.style.left = '180px';
  popup.style.height = `${submenuHeight}px`;
  popup.style.paddingTop = `${paddingTop}px`;
  popup.style.paddingBottom = `${paddingBottom}px`;

  if (settings.customLeftOffset) {
    popup.style.transform = `translateX(${settings.customLeftOffset})`;
  }

  popup.style.zIndex = `${zIndex}`;
  popup.style.top = `${offsetTop}px`;
  
  popup.classList.add('ifms-side-menu-open');

  set(containerId, {
    ...settings,
    operationInProgress: false,
    key: submenuKey,
    submenu: submenu,
    opened: true,
    index: index,
  });
}
*/

function injectSubMenu(
  containerId: string,
  submenuKey: string,
  submenu: IfmsConfigMenuItem,
  index: number,
  onMenuItemClicked: (menuItem:IfmsConfigMenuItem) => void,
  currentUrl:string,
  useDarkMode:boolean,
  showGlobalYesNoDialog?: (contentParam: string | React.ReactNode) => Promise<boolean>,
  opendOperationData?: any,
  targetIndex?:number,
) {
  const extendedSubMenuClassName = !useDarkMode ? 'ifms-sub-menu-item-withscroll' :  'ifms-sub-menu-item-withscroll-darkmode' ;
  const noClickEventSideMenuClassName = !useDarkMode ? 'ifms-sub-menu-item-withscroll-noclickevent' :  'ifms-sub-menu-item-withscroll-noclickevent-darkmode' ;
  const selectedSubMenuClassName = !useDarkMode ? 'ifms-sub-menu-item-selected-onclick' :  'ifms-sub-menu-item-selected-onclick-darkmode' ;

  async function handleClickSubMenu(x: IfmsConfigMenuItem, subMenuItemKey: any, index: number) {
    let result = false;

    if (x.moreMenuJobName) {
      if (x.metadata.operationMode === 'add') {
        return;
      }
      else {
        if (opendOperationData) {
          _.mapKeys(fastStorage, (val, key) => {
            if (!key.endsWith(getRoutePath(currentUrl))) {
              return;
            }

            if (val && val.isDirty !== undefined && val.isDirty === true) {
              result = true;
            }
          })

          if (showGlobalYesNoDialog && result) {
            const doClose = await showGlobalYesNoDialog(
              <div>
                <h3>Open {x.text} without saving <span style={{ color: 'red', fontWeight: 'bold' }}>CHANGES</span>?</h3>
              </div>
            );

            if (!doClose) {
              return;
            }
          }
        }

        // const alreadySettingsMenuOpend = document.querySelectorAll('.ifms-sub-menu-item-selected-onclick');
        // for (let i = 0; i < alreadySettingsMenuOpend.length; ++i) {
        //   alreadySettingsMenuOpend[i].className = `${extendedSideMenuClassName} parent-index${index}`;
        // }

        // const submenuDom = document.getElementById(subMenuItemKey) as HTMLElement;
        // if (submenuDom)
        //   submenuDom.className = 'ifms-sub-menu-item-selected-onclick';
      }
      onMenuItemClicked(x);
    }
    else
      onMenuItemClicked(x);
  }

  const settings = get(containerId);

  // Mark submenu as selected
  const submenuDom = document.getElementById(submenuKey) as HTMLElement;
  if (submenuDom) {
    submenuDom.classList.add(`ifms-side-menu-item-opend-${index}`);
    submenuDom.innerHTML = submenu.metadata?.emptyMenu || submenu.metadata?.hideMenu ? '' : `${submenuDom.textContent as string} ${ArrowIconSvgUp}`;
  }

  const submenuItems = submenu.items ?? [];
  const container = document.getElementById(containerId);
  if (!container) {
    throw new Error('Cannot render menu. Container is missing: ' + containerId);
  }

  for (let i = submenuItems.length - 1; i >= 0; i--) {
    if (targetIndex && index !== targetIndex) return;

    const sx = submenuItems[i];
    const subMenuItemKey = getMenuItemKey('', submenuKey, i);

    const divElement = document.createElement('div');
    divElement.id = subMenuItemKey;
    //divElement.classList.add(operation === 'Accounting' || operation === 'Ocean Import' ? extendedSideMenuClassName : 'ifms-side-menu-item-extended');
    divElement.classList.add(extendedSubMenuClassName);
    // if (!!sx.metadata?.doubleLineInMenu) {
    //   divElement.classList.add('ifms-side-menu-item-large');
    // }

    if (sx.textColor && sx.metadata.operationMode !== 'add') {
      divElement.style.color = sx.textColor;
    }
    
    if (submenu.text === 'More Menu') {
      if (sx.metadata.operationMode === 'add') {
        divElement.classList.remove(extendedSubMenuClassName);
        divElement.classList.add(noClickEventSideMenuClassName);
      } else{
        if(sx.textColor){
           divElement.style.color = sx.textColor;
         }
      }
    }

    divElement.classList.add(`parent-index${index}`)

    if (sx.metadata?.operationMode !== 'add') {
      if (sx?.metadata?.isDirectPrint)
        divElement.innerHTML = sx.text as string + ` <img width='15px' height='15px' src=${!useDarkMode ? directPrintIcon :directPrintIconWhite} />`;
      else if (sx.subMenu)
        divElement.innerHTML = sx.text as string + ` <img width='15px' height='15px' src=${!useDarkMode ? previewPrintIcon : previewPrintIconWhite} />`;
      else
        divElement.innerHTML = sx.text as string
    }
    else {
      if (sx?.metadata?.isDirectPrint)
        divElement.innerHTML = sx.text as string + ` <img width='15px' height='15px' src=${disableDirectPrintIcon} />`;
      else if (sx.subMenu)
        divElement.innerHTML = sx.text as string + ` <img width='15px' height='15px' src=${disablePreviewPrintIcon} />`;
      else
        divElement.innerHTML = sx.text as string
    }

    divElement.onclick = () => {
      //onMenuItemClicked(sx);
      handleClickSubMenu(sx, subMenuItemKey, index);
    };

    if(currentUrl === sx.link){
      divElement.className = `${selectedSubMenuClassName} parent-index${index}`;
    }
    
    submenuDom.insertAdjacentElement('afterend', divElement);

    if(sx.topLineColor) {
      const topLineElement = document.createElement('div');
      topLineElement.id = 'ifms-side-menu-extended-topline';
      topLineElement.style.borderTop = (sx.moreMenuJobName == JobNames.BTOrder || sx.moreMenuJobName == JobNames.BTLoadPlan) ? `1px solid ${sx.topLineColor}` : `2px solid ${sx.topLineColor}`;
      //topLineElement.style.paddingBottom = '3px';
      topLineElement.style.marginLeft = '30px';
      topLineElement.style.marginRight = '10px'
      submenuDom.insertAdjacentElement('afterend', topLineElement);
    }

  }

  set(containerId, {
    ...settings,
    operationInProgress: false,
    key: submenuKey,
    submenu: submenu,
    opened: true,
    index: index,
  });
}

function injectMenu(
  containerId: string,
  menuItems: IfmsConfigMenuItem[],
  operation: string,
  topBarHeight: number,
  onMenuItemClicked: (menuItem:IfmsConfigMenuItem) => void,
  useDarkMode:boolean,
  changeTitleInAnMenu:boolean,
  ediForStGeorgeWarehouse : boolean,
  currentUrl:string,
  showGlobalYesNoDialog: (contentParam: string | React.ReactNode) => Promise<boolean>,
  customTopOffset?: number|undefined,
  customLeftOffset?: string|undefined,
  customZIndex?: number|undefined,
  opendOperationData?: any,
  ) {
  const sideMenuClassName = !useDarkMode ? 'ifms-side-menu-item-withscroll' :  'ifms-side-menu-item-withscroll-darkmode' ;
  const selectedSideMenuClassName = !useDarkMode ? 'ifms-side-menu-item-selected-onclick' : 'ifms-side-menu-item-selected-onclick-darkmode'; 
  const emptySideMenuClassName = !useDarkMode ? 'ifms-side-menu-emptyItem' : 'ifms-side-menu-emptyItem-darkmode'; 
  const noClickEventSideMenuClassName = !useDarkMode ? 'ifms-side-menu-item-withscroll-noclickevent' : 'ifms-side-menu-item-withscroll-noclickevent-darkmode' ;
  const sideCaptionClassName = !useDarkMode ? 'ifms-side-menu-item-withscroll-caption' : 'ifms-side-menu-item-withscroll-caption-darkmode' ;

  function handleClick(x: IfmsConfigMenuItem, menuItemKey: string, menuIndex: number) {
    if (operation === 'Settings' || operation === 'Reference Files' || operation === 'Business Intelligence') {
      //    if (operation === 'Settings' || operation === 'Reference Files' || operation === 'Utilities') {
      if (!x.metadata.noSetBackgoundColor) {
        const alreadySettingsMenuOpend = document.querySelectorAll(`.${selectedSideMenuClassName}`);
        for (let i = 0; i < alreadySettingsMenuOpend.length; ++i) {
          alreadySettingsMenuOpend[i].className = sideMenuClassName;
        }
        const submenuDom = document.getElementById(menuItemKey) as HTMLElement;
        if (submenuDom)
          submenuDom.className = selectedSideMenuClassName;
      }
      onMenuItemClicked(x);
      return;
    }
    else {
      if (hasSideMenu(x)) { 
        // Accounting > Adjustment, OI > AMS 메뉴 등
        const alreadyMenuOpend = document.querySelectorAll(`.ifms-side-menu-item-opend-${menuIndex}`);
        if (alreadyMenuOpend.length > 0) {
          const menuDom = document.getElementById(menuItemKey);
          if (menuDom) {
            for (let i = 0; i < alreadyMenuOpend.length; ++i) {
              alreadyMenuOpend[i].classList.remove(`ifms-side-menu-item-opend-${menuIndex}`);
            }
            menuDom.innerHTML = `${menuDom.textContent as string} ${ArrowIconSvgDown}`;
          }
          const submenuItems = x.items ?? [];
          for (let i = 0; i < submenuItems.length; ++i) {
            const subMenuLKey = getMenuItemKey('', menuItemKey, i);
            const subMenuDom = document.getElementById(subMenuLKey) as HTMLElement;
            if (subMenuDom) subMenuDom.remove();
          }
          //delete more menu topline
          if (x.text === 'More Menu' || (x.items?.length ?? 0 > 0)) {
            const topLineEle = document.querySelectorAll("[id='ifms-side-menu-extended-topline']");
            for (let i = 0; i < topLineEle.length; i++) {
              topLineEle[i].remove();
            }
          }
        }
        else {
          // if (operation === 'Accounting') //accounting can only open one 
          //   makeUnSelectAllSideMenu(menuItemKey)

          // window.console.log('Submenu click');
          injectSubMenu(containerId, menuItemKey, x, menuIndex, onMenuItemClicked, currentUrl, useDarkMode, showGlobalYesNoDialog, opendOperationData);
        }
      } else {
        // 왼쪽 Side Menu에서 List View를 보여주는 Side Menu에 포커스가 있을 경우, 해당 SideMenu를 클릭하면 그 메뉴의 Sub Menu가 Fold/Unfold되도록 수정
        if (!_.isEmpty(x.moreMenuJobName) && x.level === 0) {
          if (currentUrl === x.link) {
            const findOpendSideMenu = document.getElementById(menuItemKey);
            if (findOpendSideMenu) {
              const moreMenuIndex = menuItems.findIndex(x => x.text === 'More Menu');
              const moreMenu = menuItems.find(x => x.text === 'More Menu');
              const moreMenuItemKey = getMenuItemKey(operation, 'ifms-side-menu', moreMenuIndex);
              if(!moreMenu) return;

              // Arrow Icon으로 Fold, UnFold 여부 판단
              const arrowIcon = findOpendSideMenu.querySelectorAll('svg');

              // Fold -> UnFold
              if (arrowIcon[0].classList.contains('ifms-side-menu-downarrow-icon')) { 
                const items = moreMenu.items ?? [];
                for (let i = 0; i < items.length; ++i) {
                  const subMenuLKey = getMenuItemKey('', moreMenuItemKey, i);
                  const subMenuDom = document.getElementById(subMenuLKey) as HTMLElement;
                  if (subMenuDom) subMenuDom.remove();
                }
                findOpendSideMenu.innerHTML = `${findOpendSideMenu.textContent as string} ${ArrowIconSvgUp}`;
              }
              // UnFold -> Fold
              else {
                if (moreMenuIndex > -1){
                  const container = document.getElementById(containerId);
                  if (container) {
                    const divElement = document.createElement('div');
                    divElement.id = moreMenuItemKey;
                    findOpendSideMenu.insertAdjacentElement('afterend', divElement);
                    injectSubMenu(containerId, moreMenuItemKey, moreMenu, moreMenuIndex, onMenuItemClicked, currentUrl, useDarkMode, showGlobalYesNoDialog, opendOperationData);
                    container.removeChild(divElement);
                    findOpendSideMenu.innerHTML = `${findOpendSideMenu.textContent as string} ${ArrowIconSvgDown}`;
                  }
                }
              }
            }
            return;
          }
        }
        // const submenuDom = document.getElementById(menuItemKey) as HTMLElement;
        // if (submenuDom)
        //   submenuDom.className = selectedSideMenuClassName;
        onMenuItemClicked(x);
        return;
      }
    }
  }

  /*
  function makeUnSelectAllSideMenu(menuItemKey: string) {
    const openMenus = document.querySelectorAll('[class*=ifms-side-menu-item-opend]');
    if (openMenus.length > 0) {
      for (let i = 0; i < openMenus.length; ++i) {
        const opneMenu = openMenus[i];
        opneMenu.className = 'ifms-side-menu-item';
        opneMenu.innerHTML = `${opneMenu.textContent as string} ${ArrowIconSvgDown}`;
      }
      const allUnderMenuItemExtended = document.getElementsByClassName('ifms-side-menu-item-extended');
      const allUnderMenuItemLarge = document.getElementsByClassName('ifms-side-menu-item-large');
      while (allUnderMenuItemExtended.length > 0) {
        allUnderMenuItemExtended[0].remove();
      }
      while (allUnderMenuItemLarge.length > 0) {
        allUnderMenuItemLarge[0].remove();
      }
    }
  }

  function handleMouseEnter(x: IfmsConfigMenuItem, menuItemKey: string, menuIndex: number) {
    if (hasSideMenu(x)) {
      injectPopup(containerId, menuItemKey, x, menuIndex, onMenuItemClicked,enablebranch);
    } else {
      const alreadySelected = document.querySelectorAll('.ifms-side-menu-item-selected');
      for (let i = 0; i < alreadySelected.length; ++i) {
        alreadySelected[i].classList.remove('ifms-side-menu-item-selected');
      }
    }
  }
*/

  const container = document.getElementById(containerId);
  if (!container) {
    throw new Error('Cannot render menu. Container is missing: ' + containerId);
  }

  set(containerId, {
    operationInProgress: false,
    key: '',
    submenu: null,
    opened: false,
    index: 0,
    topBarHeight,
    customLeftOffset,
    customTopOffset,
    customZIndex,
    operation,
    mX: -1,
    mY: -1,
  });

  container.innerHTML = ''; // Clear all

  // if (operation === 'Utility') {
  //   if (!showMilestoneInOihList) {
  //     menuItems[menuItems.findIndex(x => x.text?.toString().includes('OIH B/L Activity Status'))].text = 'OIH B/L Activity Status On'
  //   }
  //   if (!showMilestoneInAihList) {
  //     menuItems[menuItems.findIndex(x => x.text?.toString().includes('AIH B/L Activity Status'))].text = 'AIH B/L Activity Status On'
  //   }
  // }

  for (let i = 0; i < menuItems.length; ++i) {
    const menuItem = menuItems[i];
    const menuItemKey = getMenuItemKey(operation, 'ifms-side-menu', i);

    const divElement = document.createElement('div');
    divElement.id = menuItemKey;
    if(menuItem.name){
      const menuItemName = getMenuItemName(operation, 'ifms-side-menu', menuItem.name);
      // @ts-ignore:next-line
      divElement.name = menuItemName;
    }

    // if (!menuItem.metadata?.emptyMenu)
    //   divElement.classList.add(operation === 'Accounting' || operation === 'Ocean Import' ? sideMenuClassName : 'ifms-side-menu-item');
    // else
    //   divElement.classList.add('ifms-side-menu-emptyItem');
    if (!menuItem.metadata?.emptyMenu)
      divElement.classList.add(sideMenuClassName);
    else
      divElement.classList.add(emptySideMenuClassName);

    if (menuItem.disableOpertaionView && opendOperationData) {
      divElement.classList.add(noClickEventSideMenuClassName);
    }

    if (menuItem.textColor) {
      divElement.style.color = menuItem.textColor;
    }

    // if (!!menuItem.metadata?.doubleLineInMenu) {
    //   divElement.classList.add('ifms-side-menu-item-large');
    // }
    if (!menuItem.metadata?.emptyMenu) {
      divElement.onclick = () => {
        handleClick(menuItem, menuItemKey, i);
      }
    }
    // divElement.onmouseenter = () => {
    //   handleMouseEnter(menuItem, menuItemKey, i);
    // }

    //SideMenu disable 시킴
    if(menuItem.disable) { 
      divElement.style.opacity = '0.2';
      divElement.style.pointerEvents = 'none';
    }

    if(menuItem.topLineColor) {
      const topLineElement = document.createElement('div');
      topLineElement.id = 'ifms-side-menu-topline';
      topLineElement.style.borderTop = `1px solid ${menuItem.topLineColor}`;
      //topLineElement.style.paddingBottom = '3px';
      //operation !== 'Accounting' ? topLineElement.style.marginLeft = '22px' : topLineElement.style.marginLeft = '10px';
      topLineElement.style.marginLeft = '20px';
      topLineElement.style.marginRight = '2px'
      if(menuItem.topLineShort) topLineElement.style.width = '105px'
      container.appendChild(topLineElement);
    }

    divElement.innerHTML =
      (hasSideMenu(menuItem) || menuItem.moreMenuJobName) && (!(operation === 'Settings' || operation === 'Reference Files' || operation === 'Billings' || operation === 'Orchid Baaro'))
        ?
        `${menuItem.text as string} ${ArrowIconSvgDown}`
        :
        (menuItem.metadata?.isDirectPrint ?
          (menuItem.text as string + ` <img width='15px' height='15px' src=${!useDarkMode ? previewPrintIcon : previewPrintIconWhite} />`)
          :
        (menuItem.metadata?.isShipmentStatus) ?
        (`<div style="display: inline-block; width: 10px; height: 10px; background-color: #${menuItem.metadata?.isShipmentStatus}; margin-right: 6px;"></div>` + menuItem.text as string ) 
        :  
          (menuItem.text as string)
        );
    

    if (menuItem.subMenu) divElement.innerHTML += ` <img width='15px' height='15px' src=${!useDarkMode ? previewPrintIcon : previewPrintIconWhite} />`;

    container.appendChild(divElement);

    //Default open menu 
    if ((menuItem.text === 'More Menu' || (operation === "Accounting" && menuItem.text === 'Financial Report')) && hasSideMenu(menuItem)) {
    // if (menuItem.text === 'More Menu' && hasSideMenu(menuItem)) {
        if (!!opendOperationData) {
        if (opendOperationData.jobName === JobNames.OIMbl) {
          let menuIndex = menuItem.items?.findIndex(x => x.text === 'CFS Manifest');
          if (menuIndex !== undefined && !ediForStGeorgeWarehouse)
            menuItem.items?.splice(menuIndex, 1);
        }
        else if (opendOperationData.jobName === JobNames.OIHbl) {
          let menuIndex = menuItem.items?.findIndex(x => x.text === 'Arrival Notice' && x.link !== null);
          if (menuIndex !== undefined && !changeTitleInAnMenu)
            menuItem.items?.splice(menuIndex, 1);
          else if (menuIndex !== undefined)
            menuItem.items?.splice(menuIndex + 1, 1);

          menuIndex = menuItem.items?.findIndex(x => x.text === 'CFS Release');
          if (menuIndex !== undefined && !ediForStGeorgeWarehouse)
            menuItem.items?.splice(menuIndex, 1);
        }
        else if (opendOperationData.jobName === JobNames.AIHbl) {
          let menuIndex = menuItem.items?.findIndex(x => x.text === 'Arrival Notice' && x.link !== null);
          if (menuIndex !== undefined && !changeTitleInAnMenu)
            menuItem.items?.splice(menuIndex, 1);
          else if (menuIndex !== undefined)
            menuItem.items?.splice(menuIndex + 1, 1);
        }
      }
      injectSubMenu(containerId, menuItemKey, menuItem, i, onMenuItemClicked, currentUrl ?? '', useDarkMode, showGlobalYesNoDialog, opendOperationData);

      //hide more menu in list view
      if (menuItem.metadata?.hideMenu)
        container.removeChild(divElement);
    }
  }

  if (operation === 'ISF') {
    const divElement = document.createElement('div');
    divElement.style.marginTop = '70px';
    divElement.classList.add(sideCaptionClassName);
    divElement.innerHTML = `<div style='display: flex'><span class='side-caption-label' style='font-size: 13px;'>&#9654; Upload Procedure</span></div>
    <div style='display: flex; flex-direction: column; gap: 10px; margin-top: 5px;'>
      <div style='display: flex'><span class='side-caption-label'>1.</span> Click Std. ISF Excel Form (Download) <br>& Email to Your Partners.</div>
      <div style='display: flex'><span class='side-caption-label'>2.</span> After receiving <br>ISF Excel Form (filled), <br> you should save in your PC.</div>
      <div style='display: flex'><span class='side-caption-label'>3.</span> After that, click <br>"ISF Upload" Menu.</div>
      <div style='display: flex'><span class='side-caption-label'>4.</span> You will see <br>ISF Filing Upload Screen.</div>
      <div style='display: flex'><span class='side-caption-label'>5.</span> After browsing <br>ISF Excel Form for uploading, <br>click Upload button.</div>
    </div>`;

    container.appendChild(divElement);
  }

  // Create empty popup holder
  const popupContainerId = `${containerId}-popup`;
  const existingPopup = document.getElementById(popupContainerId);
  if (existingPopup) {
    existingPopup.innerHTML = '<div class="ifms-side-menu"></div>'; // Placeholder for drawer
  } else {
    const popupDivElement = document.createElement('div');
    popupDivElement.id = popupContainerId;
    popupDivElement.innerHTML = '<div class="ifms-side-menu"></div>'; // Placeholder for drawer

    // Portal popup into the DOM where they belong to
    const parent = document.getElementById('ifms-app-poppers');
    parent?.appendChild(popupDivElement);
  }

  // if (!(operation === 'Settings' || operation === 'Reference Files' || operation === 'Utilities')) {
  //   const findOpendMenuIndex = menuItems?.findIndex(x => x.link?.includes(currentUrl ?? '')) ?? 0;
  //   if (findOpendMenuIndex !== -1) {
  //     const menuItemKey = getMenuItemKey(undefined, operation, 'ifms-side-menu', findOpendMenuIndex);
  //     const findOpendSideMenu = document.getElementById(menuItemKey);
  //     if (findOpendSideMenu)
  //       findOpendSideMenu.className = selectedSideMenuClassName;
  //   }
  // }
}

function IfmsSideMenu({
  parentId,
  menuId,
  menus,
  onMenuItemClicked,
  operation,
  topBarHeight,
  noTitle = false,
  customTopOffset = undefined,
  customLeftOffset = undefined,
  customZIndex = undefined,
  enableBranch = false,
  opendOperationData,
}: {
  parentId: string,
  menuId: string,
  menus : IfmsConfigOperationMenu|null|undefined,
  onMenuItemClicked: (menuItem:IfmsConfigMenuItem) => void,
  operation: string,
  topBarHeight: number,
  noTitle?: boolean,
  customTopOffset?: number|undefined,
  customLeftOffset?: string|undefined,
  customZIndex?: number|undefined,
  enableBranch?: boolean,
  opendOperationData?: any
}) {
  useSideMenuHeightMonitor(parentId);
  const history = useHistory();
  const injectMenuId = `${menuId}-inject-container`;
  const hasJob = !!menus && !!menus.job && menus.job.length > 0;
  const hasDownload = !!menus && !!menus.download && menus.download.length > 0;
  const hasReport = !!menus && !!menus.report && menus.report.length > 0;
  const hasPreReport = !!menus && !!menus.preReport && menus.preReport.length > 0;
  const hasOperationReport = !!menus && !!menus.operationReport && menus.operationReport.length > 0;
  const hasMoreMenu = !!menus && !!menus.moreMenu && menus.moreMenu.length > 0;
  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();
  
  const currentUrl = `${history.location.pathname}${history.location.search}`;
  const appcontext = useContext(ApplicationContext);

  const systemSettings = useSystemSettings();
  enableBranch = appcontext.systemSettings?.enableBranch??false;

  const renderingMenuItems: IfmsConfigMenuItem[] = [];

  function setupMenu() {
    if (hasJob) {
      renderingMenuItems.splice(renderingMenuItems.length, 0, ...menus.job);
    }
    if (hasOperationReport) {
      renderingMenuItems.splice(renderingMenuItems.length, 0, ...menus.operationReport!);
    }
    if (hasDownload) {
      renderingMenuItems.splice(renderingMenuItems.length, 0, ...menus.download!);
    }
    if (hasPreReport) {
      renderingMenuItems.splice(renderingMenuItems.length, 0, ...menus.preReport!);
    }
    if (hasReport) {
      renderingMenuItems.splice(renderingMenuItems.length, 0, ...menus.report!);
    }
    if (hasMoreMenu) {
      renderingMenuItems.splice(renderingMenuItems.length, 0, ...menus.moreMenu!);
    }
  }

  useDeepCompareEffect(() => {
    setupMenu();
    injectMenu(injectMenuId, renderingMenuItems, operation, topBarHeight, onMenuItemClicked, appcontext.useDarkMode, systemSettings.bl?.changeTitleInAnMenu ?? false, 
      appcontext.suntekSettings?.edi?.ediForStGeorgeWarehouse ?? false, currentUrl, showGlobalYesNoDialog, customTopOffset, customLeftOffset, customZIndex, opendOperationData);
  },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [operation, menus, appcontext.useDarkMode, currentUrl]
  );

  useEffect(()=>{
    setupMenu();

    const links = renderingMenuItems.filter(x => (x.items?.length ?? 0) > 0).flatMap(x => x.items?.map(item => item.link) ?? []);
    if (links && links.findIndex(x => currentUrl.includes(x ?? '')) !== -1) {
      const foundIndex = renderingMenuItems.findIndex(menuItem => {
        return menuItem.items && menuItem.items.some(item => item.link === currentUrl);
      });
      if (foundIndex !== -1) {
        const menuItem = renderingMenuItems[foundIndex];
        const menuItemKey = getMenuItemKey(operation, 'ifms-side-menu', foundIndex);

        if (!findOpendSideMenuIndexes().some(x => Number(String(x).replace(/[^0-9]/g, "")) === foundIndex))
        injectSubMenu(injectMenuId, menuItemKey, menuItem, foundIndex, onMenuItemClicked, currentUrl, appcontext.useDarkMode, showGlobalYesNoDialog, opendOperationData, foundIndex);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[currentUrl])


  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside, true);
    document.addEventListener('mousemove', processMouseMove);
    return () => {
      document.removeEventListener('mousemove', processMouseMove);
      document.removeEventListener('mousedown', handleClickOutside, true);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Determine if the popup needs to be closed on mouse outside menu or popup window
  function processMouseMove(e:MouseEvent) {
    const settings = get(injectMenuId);
    set(injectMenuId, {
      ...get(injectMenuId),
      mX: e.clientX,
      mY: e.clientY,
    });

    if (settings.opened) {
      //setTimeout(() => checkAndClosePopup(injectMenuId, settings.key), AutoCloseDelayMs);
    }
  }

  function handleClickOutside(e:MouseEvent) {
    // if the mouse click was over top menu - ignore it
    const elements = document.elementsFromPoint(e.clientX, e.clientY);
    if (elements.some(x => x.classList.contains('rc-menu-item'))) {
      return;
    }

    const target = e.target as Node|null;
    const sideMenu = document.getElementById(menuId);
    if (sideMenu && sideMenu.contains(target)) {
      return;
    }

    const popupContainerId = `${injectMenuId}-popup`;
    const popup = document.getElementById(popupContainerId);
    if (popup && popup.contains(target)) {
      return;
    }

    const reportPopup = document.querySelectorAll('[class^="report-popup"]');
    for(let i = 0 ; i<reportPopup.length;i++){
      if (reportPopup[i] && reportPopup[i].contains(target)) {
        return;
      }
    }
  }

  //const displayOperation = operation !== 'Standalone' && operation !== 'Customer List' ? operation : '';
  var displayOperation = ''
  if (operation !== 'Standalone') 
    //displayOperation = operation !== 'Utilities' ? operation : 'Util';
    displayOperation = operation;

  const menuContainerStyle:React.CSSProperties = {};
  if (customZIndex !== undefined) {
    menuContainerStyle['zIndex'] = customZIndex;
  }

  let sideMenuClassName = '';
    sideMenuClassName = !appcontext.useDarkMode ? 'ifms-side-menu-withscroll' : 'ifms-side-menu-withscroll-darkmode';
  // if (operation === 'Accounting' || operation === 'Ocean Import')
  //   sideMenuClassName = 'ifms-side-menu-withscroll';
  // else
  //   sideMenuClassName = 'ifms-side-menu-main';

  return (
    <div id={menuId} className="ifms-side-menu-main" style={menuContainerStyle}> 
      {!noTitle &&
        <div className={!appcontext.useDarkMode ? "ifms-side-menu-operation-title" : "ifms-side-menu-operation-title-darkmode"}>
          {displayOperation}
        </div>
      }
      <div className={sideMenuClassName} >
        <div style={{ height: '14px' }}>
          {/* {operation === 'Accounting' || operation === 'Ocean Import' ?
          <div style={{ borderTop: '3px solid #dc3545', height: '2px', marginLeft: '20px', marginRight: '10px', position: 'relative', top: '6px' }}></div>
          :
          <div style={{ borderTop: '3px solid #dc3545', height: '2px', marginLeft: '20px', marginRight: '20px', position: 'relative', top: '6px' }}></div>
        } */}
        <div style={{ borderTop: '3px solid #dc3545', height: '2px', marginLeft: '20px', marginRight: '10px', position: 'relative', top: '6px' }}></div>
        </div>


        <div id={injectMenuId}></div>
      </div>
    </div>
  );
}

export default React.memo(IfmsSideMenu);
